import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import ArrowRight from '../../../assets/images/ArrowRight.svg'
import Link from '../Link'
import Button from '../Button/index'

import {
  ctaListContainer,
  ctaListInnerContainer,
  ctaListWrapper,
  ctaListWrapperRule,
  ctaListTitle,
  ctaBlock,
  ctaImage,
  ctaContent,
  ctaLink,
  ctaLinkArrow,
  buttonBlock,
  buttonCta,
} from './index.module.css'

const Image = ({ component }) => {
  return component?.image.fluid ? (
    <GatsbyImage
      image={component?.childImageSharp?.gatsbyImageData}
      className={ctaImage}
      alt={component.image.description}
      imgStyle={{
        objectFit: 'contain',
        objectPosition: '50% 50%',
      }} />
  ) : (
    <img
      className={ctaImage}
      src={component?.image?.file?.url}
      alt={component.image.description}
      style={{
        objectFit: 'contain',
        objectPosition: '50% 50%',
      }}
    />
  );
}

const CTAListWithTitlesAndImages = ({
  title,
  ctaText,
  ctaUrl,
  anchorID,
  backgroundColor,
  components,
}) => {
  return (
    <div
      className={ctaListContainer}
      id={anchorID || 'ctaList'}
      style={{ backgroundColor }}
    >
      <div className="wrapper">
        <div className={ctaListInnerContainer}>
          <div
            className={[
              ctaListWrapper,
              ctaUrl && ctaText ? '' : ctaListWrapperRule,
            ].join(' ')}
          >
            <h4 className={ctaListTitle}>{title}</h4>
            {components.map((component) => (
              <div key={component?.id} className={ctaBlock}>
                {component?.image && (
                  <>
                    {component.ctaUrl ? (
                      <Link to={component.ctaUrl}>
                        <Image component={component} />
                      </Link>
                    ) : (
                      <Image component={component} />
                    )}
                  </>
                )}
                <div className={ctaContent}>
                  {component.ctaUrl ? (
                    <Link to={component.ctaUrl}>
                      <p className="paragraph">{component?.title}</p>
                    </Link>
                  ) : (
                    <p className="paragraph">{component?.title}</p>
                  )}
                  {component.ctaUrl && component.ctaText && (
                    <>
                      {component?.ctaDefaultDisplay ||
                      component?.ctaDefaultDisplay === null ? (
                        <Link className={ctaLink} to={component.ctaUrl}>
                          {component.ctaText}{' '}
                          <ArrowRight
                            className={ctaLinkArrow}
                            style={{
                              display: 'inline',
                              alignSelf: 'center',
                              position: 'relative',
                              marginLeft: '10px',
                            }}
                          />
                        </Link>
                      ) : (
                        <Link className={ctaLink} to={component.ctaUrl}>
                          <Button inverted>{component.ctaText}</Button>
                        </Link>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
            {ctaUrl && ctaText && (
              <div className={buttonBlock}>
                <Link className={buttonCta} to={ctaUrl}>
                  <Button>{ctaText}</Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CTAListWithTitlesAndImages
